import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3a9 9 0 0 0-7.838 13.427q.003.016.008.026c.115.222.078.534 0 .792l-.578 1.848-.6 1.916 1.915-.6 1.848-.58.012-.003c.234-.068.568-.09.779-.004A9 9 0 1 0 12 3M7.057 21.83A10.95 10.95 0 0 0 12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12c0 1.778.422 3.457 1.17 4.943l-1.628 5.27a1 1 0 0 0 1.245 1.245zm5.201-13.806a2 2 0 0 0-2.225 1.308 1 1 0 1 1-1.886-.664 4 4 0 0 1 7.773 1.333c0 1.53-1.135 2.54-1.945 3.081a8 8 0 0 1-1.686.848l-.035.013-.011.003-.004.002h-.002L11.92 13l.316.949a1 1 0 0 1-.633-1.897H11.6h.003l.015-.006.074-.027a6.051 6.051 0 0 0 1.172-.6c.69-.46 1.055-.95 1.055-1.419v-.001a2 2 0 0 0-1.662-1.975M12 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }